import { useTranslation } from "react-i18next";
import imgBlack from "../assets/TWH1-black.png";
import imgWhite from "../assets/TWH1-white.png";
import { useTheme } from "next-themes";

export const FooterCopy = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  return (
    <footer className="w-full   p-1 text-xs flex justify-center items-center  text-center ">
      <a
        href="https://twhmenu.com/"
        target="_blank"
        rel="noreferrer"
        className="flex gap-1 items-center justify-center"
      >
        {t("gloabl.ProducedBy")}
        <img
          width={35}
          height={15}
          src={theme === "dark" ? imgWhite : imgBlack}
          alt="cl"
        />
      </a>
    </footer>
  );
};
